var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7799 19.252L34.7929 13.7275V4.67686H27.8963V7.36409L20.9997 1L1.22014 19.252C0.941512 19.5097 0.924961 19.9435 1.18427 20.2211C1.4429 20.498 1.87945 20.5138 2.15946 20.2567L4.44845 18.1445V41H15.483H26.5176H37.5522V18.1438L39.8412 20.2561C39.9736 20.3787 40.1426 20.439 40.3109 20.439C40.4964 20.439 40.6806 20.3657 40.8157 20.2204C41.075 19.9435 41.0585 19.5097 40.7799 19.252ZM29.2756 6.04755H33.4136V12.4548L29.2756 8.63677V6.04755ZM16.8617 39.6293V25.194C16.8617 24.8396 17.1513 24.5518 17.5079 24.5518H24.4914C24.848 24.5518 25.1376 24.8396 25.1376 25.194V39.6293H16.8617ZM36.1722 39.6293H26.517V25.194C26.517 24.0837 25.6087 23.1811 24.4914 23.1811H17.5079C16.3906 23.1811 15.4824 24.0837 15.4824 25.194V39.6293H5.82708V16.8712L20.9997 2.8703L30.848 11.9579L34.7929 15.5978L36.1722 16.8705V39.6293Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.db2abe5d9f7388227e83500fd7d3a844.svg";
export { ForwardRef as ReactComponent };